import { BaseLayout, type NavSection } from './BaseLayout';
import {
  LayoutDashboard,
  Users, GraduationCap,
  User, Megaphone,
} from 'lucide-react';
import { useProfileBrandColor } from '../../theme/useProfileBrandColor';
import { useAuthStore } from '../../store/authStore';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';

/**
 * Layout dedicado para Gestores de Rede Escolar.
 * Sidebar simplificado: Dashboard, Video Aulas e Gestão de Usuários.
 */
const REDE_SECTIONS: NavSection[] = [
  {
    title: null,
    items: [
      { to: '/rede/dashboard', label: 'Dashboard', icon: LayoutDashboard },
      { to: '/rede/ead', label: 'Video Aulas', icon: GraduationCap },
    ],
  },
  {
    title: 'Gestão',
    items: [
      { to: '/rede/usuarios', label: 'Usuários', icon: Users },
    ],
  },
  {
    title: 'Minha Conta',
    items: [
      { to: '/rede/perfil', label: 'Meu Perfil', icon: User },
      { to: '/rede/alertas', label: 'Meus Comunicados', icon: Megaphone },
    ],
  },
];

export function RedeLayout() {
  const { brandColor, brandGradient } = useProfileBrandColor('REDE');
  const user = useAuthStore((s) => s.user);
  const redeId = user?.redeId || (user as any)?.rede_id || (user as any)?.redeEnsinoId;

  const { data } = useQuery<{ rede?: { nome: string; tipo?: string } }>({
    queryKey: ['rede-info', redeId],
    queryFn: async () => {
      if (!redeId) return { rede: undefined };
      const res = await api.get(`/redes/${redeId}/dashboard`);
      return res.data;
    },
    enabled: Boolean(redeId),
    staleTime: 1000 * 60 * 15,
  });

  const redeNome = data?.rede?.nome || user?.preferencias?.redeNome || 'Gestão da Rede';

  return (
    <BaseLayout
      sections={REDE_SECTIONS}
      headerTitle="Painel da Rede"
      brandLabel="REDE"
      brandSubtitle={redeNome}
      brandColor={brandColor}
      brandGradient={brandGradient}
    />
  );
}

